module.exports = __webpack_public_path__ + "83d9e64b042c43397d1c1933e0a63cbe.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/Foto_Manja_Herrmann-8386_klein.jpg
// module id = 460
// module chunks = 0